import React, { Component } from 'react'
import { Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getData = schedule => {
    return (
      <div key={schedule.id}>
        {/* Overview */}
        <h6 className="marginTop20">Overview</h6>
        {schedule.job_type !== 'Maintenance/Service' && (
          <div>
            <div>
              <p className="jobDetailsHeader marginBottom0">Executed Contract</p>
              <p>
                {schedule.executed_contract_date
                  ? moment(schedule.executed_contract_date).format('YYYY-M-D')
                  : 'Not Entered'}
              </p>
            </div>
            {schedule.job_type !== 'Material Sale' && (
              <div>
                <div>
                  <p className="jobDetailsHeader marginBottom0">AIA Due Day</p>
                  <p>{schedule.aia_due_day ? schedule.aia_due_day : 'Not Entered'}</p>
                </div>
                <div>
                  <p className="jobDetailsHeader marginBottom0">AIA Expected Pay Day</p>
                  <p>
                    {schedule.aia_expected_pay_day ? schedule.aia_expected_pay_day : 'Not Entered'}
                  </p>
                </div>
              </div>
            )}
          </div>
        )}
        {schedule.job_type === 'Maintenance/Service' && (
          <div>
            <div>
              <p className="jobDetailsHeader marginBottom0">Monthly Invoice Date</p>
              <p>
                {schedule.monthly_invoice_day
                  ? moment(schedule.monthly_invoice_day).format('YYYY-M-D')
                  : 'Not Entered'}
              </p>
            </div>
            <div>
              <p className="jobDetailsHeader marginBottom0">CAT 1 Due</p>
              <p>
                {schedule.cat1_due_date
                  ? moment(schedule.cat1_due_date).format('YYYY-M-D')
                  : 'Not Entered'}
              </p>
            </div>
            <div>
              <p className="jobDetailsHeader marginBottom0">CAT 5 Due</p>
              <p>
                {schedule.cat5_due_date
                  ? moment(schedule.cat5_due_date).format('YYYY-M-D')
                  : 'Not Entered'}
              </p>
            </div>
            <div>
              <p className="jobDetailsHeader marginBottom0">Targeted Monthly Visit Day</p>
              <p>
                {schedule.targeted_monthly_visit_day
                  ? schedule.targeted_monthly_visit_day
                  : 'Not Entered'}
              </p>
            </div>
          </div>
        )}
        {schedule.job_type === 'Material Sale' && (
          <div>
            {/* Drawings */}
            <h6 className="marginTop20">Drawings</h6>
            {this.getDrawingsData(schedule)}
            {/* Manufacturing */}
            <h6 className="marginTop20">Manufacturing</h6>
            {this.getManufacturingData(schedule)}
          </div>
        )}
      </div>
    )
  }

  getDrawingsData = schedule => {
    let drawingsList = []
    schedule.drawings.forEach(item => {
      drawingsList.push(
        <div key={item.id}>
          {schedule.drawings.length > 1 && <h6 className="marginTop20">{item.name}</h6>}
          <div className="row" key={item.id}>
            {item.requested_preliminary_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">
                  Requested Preliminary Layout Drawings
                </p>
                <p>
                  {item.requested_preliminary_drawings_date
                    ? moment(item.requested_preliminary_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.received_preliminary_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">
                  Received Preliminary Layout Drawings
                </p>
                <p>
                  {item.received_preliminary_drawings_date
                    ? moment(item.received_preliminary_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.sent_preliminary_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Sent Preliminary Layout Drawings</p>
                <p>
                  {item.sent_preliminary_drawings_date
                    ? moment(item.sent_preliminary_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.requested_final_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Requested Final Layout Drawings</p>
                <p>
                  {item.requested_final_drawings_date
                    ? moment(item.requested_final_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.received_final_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Received Final Layout Drawings</p>
                <p>
                  {item.received_final_drawings_date
                    ? moment(item.received_final_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.sent_final_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Sent Final Layout Drawings</p>
                <p>
                  {item.sent_final_drawings_date
                    ? moment(item.sent_final_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.final_approved_layout_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Final Approved Layout Drawings</p>
                <p>
                  {item.final_approved_layout_drawings_date
                    ? moment(item.final_approved_layout_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.requested_preliminary_design_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">
                  Requested Preliminary Design Drawings
                </p>
                <p>
                  {item.requested_preliminary_design_drawings_date
                    ? moment(item.requested_preliminary_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.received_preliminary_design_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">
                  Received Preliminary Design Drawings
                </p>
                <p>
                  {item.received_preliminary_design_drawings_date
                    ? moment(item.received_preliminary_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.sent_preliminary_design_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Sent Preliminary Design Drawings</p>
                <p>
                  {item.sent_preliminary_design_drawings_date
                    ? moment(item.sent_preliminary_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.requested_final_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Requested Final Design Drawings</p>
                <p>
                  {item.requested_final_design_drawings_date
                    ? moment(item.requested_final_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.received_final_design_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Received Final Design Drawings</p>
                <p>
                  {item.received_final_design_drawings_date
                    ? moment(item.received_final_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.sent_final_design_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Sent Final Design Drawings</p>
                <p>
                  {item.sent_final_design_drawings_date
                    ? moment(item.sent_final_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.final_approved_design_drawings_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Final Approved Design Drawings</p>
                <p>
                  {item.final_approved_design_drawings_date
                    ? moment(item.final_approved_design_drawings_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
          </div>
        </div>
      )
    })
    return drawingsList
  }

  getManufacturingData = schedule => {
    let manufacturingsList = []
    schedule.manufacturings.forEach(item => {
      manufacturingsList.push(
        <div key={item.id}>
          {schedule.manufacturings.length > 1 && <h6 className="marginTop20">{item.name}</h6>}
          <div className="row" key={item.id}>
            {item.release_for_manufacturing_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Release For Manufacturing</p>
                <p>
                  {item.release_for_manufacturing_date
                    ? moment(item.release_for_manufacturing_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.requested_shipment_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Requested Shipment</p>
                <p>
                  {item.requested_shipment_date
                    ? moment(item.requested_shipment_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.estimated_shipment_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Estimated Shipment</p>
                <p>
                  {item.estimated_shipment_date
                    ? moment(item.estimated_shipment_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.confirmed_shipment_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Confirmed Shipment</p>
                <p>
                  {item.confirmed_shipment_date
                    ? moment(item.confirmed_shipment_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.estimated_delivery_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Estimated Delivery</p>
                <p>
                  {item.estimated_delivery_date
                    ? moment(item.estimated_delivery_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.final_inspection_start_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Final Inspection</p>
                <p>
                  {item.final_inspection_start_date
                    ? moment(item.final_inspection_start_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
            {item.confirmed_delivery_date && (
              <div className="col-4">
                <p className="jobDetailsHeader marginBottom0">Confirmed Delivery</p>
                <p>
                  {item.confirmed_delivery_date
                    ? moment(item.confirmed_delivery_date).format('YYYY-M-D')
                    : 'Not Entered'}
                </p>
              </div>
            )}
          </div>
        </div>
      )
    })
    return manufacturingsList
  }

  getScheduleList = () => {
    const { fullReport } = this.props
    let scheduleList = []

    fullReport.forEach(item => {
      scheduleList.push(
        <div key={item.job_id + '_' + item.id}>
          <h5 className="steps">{item.job_name}</h5>
          {this.getData(item)}
        </div>
      )
    })
    return scheduleList
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Schedules</h5>
                  {this.getScheduleList()}
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/maintenance_dob/maintenance-schedules/ListItem.js